import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  CircularProgress,
  Divider,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
 
} from "@material-ui/core";
import {
  AddRefrenceDataList,
  
  PutRefrenceDataList,
  deleteItem,
  getEmployee,
  getInvoiceType,
  getOneEmployee,
} from "../AdminSetting/adminaction";
import { makeStyles } from "@material-ui/styles";
import { Backdrop } from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";
import { dashboardStyle } from "../Components/InvoiceDetails/style";
import {  Delete } from "@mui/icons-material";


const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const useStyles = makeStyles(dashboardStyle);

export default function VAModel({
  setOpenModel,
  getdata,
  updateId,
  setUpdateId,
  togglebutton,
  settogglebutton,
  deleteId,
  setDeleteID,
  setSuccessMessage,
  setErrorMessage,
  getdataFromID,
  setGetDataFromID,
  setGetData,
  userData


}) {
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [vendorTextList, setVendorTextList] = useState([])


  const [formState, setFormState] = useState({
    referenceId: 0,
    referenceKey: "VendorAccess",
    referenceCode: "",
    referenceText: "",
    referenceProp1: "",
    referenceProp2: "",
    referenceProp3: "",
    referenceProp4: "",
    isActive: true,
    VendorAccess :""
  });

  
  const submitHandler = (e, w) => {
    e.preventDefault();
    
    if (updateId) {
      PutRefrenceDataList(formState, setFormState, setSuccessMessage, setErrorMessage, setLoader,
        setGetData,
        handleClose,

      );

    } else {

      AddRefrenceDataList(
        formState,
        setFormState,
        setLoader,
        setSuccessMessage,
        setErrorMessage,
        setGetData,

        handleClose

      );
    }
  };

  useEffect(() => {

    
  }, [loader]);
  

  const enableDisable = () => {
    PutRefrenceDataList(
      formState,
      setFormState,
      setSuccessMessage,
      setErrorMessage,
      setLoader,
      setGetData,

      handleClose


    );

  };
  const Delete = () => {
    deleteItem(
      formState,
      setFormState,
  deleteId,

      setLoader,
      setSuccessMessage,
      setErrorMessage,
      setGetData,

      handleClose

    );
  };


  const clearState = (setFormState, setUpdateId, setDeleteID, settogglebutton, setGetDataFromID) => {
   

    setUpdateId("");
    setDeleteID("");
    settogglebutton("")
    setGetDataFromID("")
  };
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));

  };


  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setOpenModel(false);

    clearState(setFormState, setUpdateId, setDeleteID, settogglebutton, setGetDataFromID);

    // setErrAlertMessage("")
  };
  
  
  const [enable, setEnable] = useState(false);


      const autocompleteChangeHandler = (name, value) => {
    setFormState((formState) => ({
      ...formState,
      [name]: value?.userId,
    }));
  }

  useEffect(() => {
    handleClickOpen();
    if (updateId || deleteId) {
      const update = getdata.filter(
        (value) => getdataFromID === value.referenceId
      );


      const userId = {
       userId : update[0]?.vendorAccess
      }

      autocompleteChangeHandler("VendorAccess", userId )
      

      setFormState((formState) => ({
        ...formState,
        referenceId: update[0]?.referenceId,
        referenceKey: update[0]?.referenceKey,
        referenceCode: update[0]?.referenceCode,
        referenceText: update[0]?.referenceText,
        referenceProp1: update[0]?.referenceProp1,
        referenceProp2: update[0]?.referenceProp2,
        referenceProp3: update[0]?.referenceProp3,
        referenceProp4: update[0]?.referenceProp4 || "",
        isActive: update[0]?.isActive ? true : false,
        // VendorAccess : update[0]?.vendorAccess
        
      }));
      setVendorTextList(update[0]?.vendorAccess.split(","))
     
    } else if (togglebutton) {
      
      const toggle = getdata.filter(
        (value) => togglebutton === value.referenceId
      );
      

      setFormState((formState) => ({
        ...formState,
        referenceId: toggle[0]?.referenceId,
        referenceKey: toggle[0]?.referenceKey,
        referenceCode: toggle[0]?.referenceCode||"",
        referenceText: toggle[0]?.referenceText||"",
        referenceProp1: toggle[0]?.referenceProp1||"",
        referenceProp2: toggle[0]?.referenceProp2||"",
        referenceProp3: toggle[0]?.referenceProp3 ||"",
        referenceProp4: toggle[0]?.referenceProp4 || "",
        isActive: toggle[0]?.isActive ? false : true,
        VendorAccess : toggle[0]?.vendorAccess
      }));
      setEnable(toggle[0]?.isActive)
      
    }
   
  }, [updateId,deleteId,togglebutton]);


  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        // sx={{ width: "60%" }}
        fullWidth={true}
      >
        {deleteId ? (
          <>
            <DialogContent>
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={loader}
              >
                <CircularProgress color="inherit" />
              </Backdrop>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <HelpOutline color="secondary" fontSize="large" mt={2} />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
                p={2}
                mt={1}
              >
                <Typography variant="h4" style={{ width: "80%" }}>
                  Are you sure you want to Delete a User?
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
                m={1}
              >
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                >
                  NO
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ marginLeft: "20px" }}
                  onClick={Delete}
                >
                  Yes
                </Button>
              </Box>
            </DialogContent>
          </>
        ) : (
          <>
            {togglebutton ? (
              <>
                <DialogContent>
                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={loader}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <HelpOutline color="secondary" fontSize="large" mt={2} />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                    p={2}
                    mt={1}
                  >
                    <Typography variant="h4" style={{ width: "80%" }}>
                     {enable ?"Are you sure you want to Disable this Item?" : "Are you sure you want to Enable this Item?" } 
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                    m={1}
                  >
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={handleClose}
                    >
                      NO
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      style={{ marginLeft: "20px" }}
                      onClick={enableDisable}
                    >
                      Yes
                    </Button>
                  </Box>
                </DialogContent>
              </>
            ) : (
              <>
                <form onSubmit={(e) => submitHandler(e)}>
                  <DialogTitle
                    sx={{
                      fontWeight: "bold",
                      fontSize: "20px",
                    }}
                  >
                  Vendor Access
                  </DialogTitle>
                  <Divider />
                  <DialogContent>
                    <Backdrop
                      sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                      }}
                      open={loader}
                    >
                      <CircularProgress color="inherit" />
                    </Backdrop>
                    <Grid container spacing={2} pb={3}>
                     <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControl fullWidth size="small">
                          <InputLabel id="demo-simple-select-label">
                            Select User
                          </InputLabel>
                            <Select
                                                    displayEmpty
                                                    labelId="demo-simple-select-label"
                                                    id="demo-multiple-name"
                                                    
                                                    required
                                                    label="Select User"
                        
                                                    value={vendorTextList}
                                                   
                                                    onChange={(event) => {
                                                      const {
                                                        target: { value },
                                                      } = event;
                                                      
                                                       setVendorTextList(
                                                        // On autofill we get a stringified value.
                                                        typeof value === "string" ? value.split(",") : value
                                                      );
                                                      setFormState((formState)=>({
                                                        ...formState,
                                                        vendorAccess:value.toString()
                                                      }))
                                                    }}
                                                    
                                                    MenuProps={MenuProps}
                                                  >
                                                   
                                                   {
                                                        userData?.length > 0 ?(
                                                          userData.map((item) => (
                                                            <MenuItem value={item.userId
                                                            }>
                                                              {item.userName }
                                                            </MenuItem>
                                                          ))
                        
                                                        ):(
                                                          <MenuItem value="">
                                                          No option
                                                        </MenuItem>
                        
                                                        )
                        
                                                    }
                        
                        
                        
                                                  </Select>
                           
                        </FormControl>

                      </Grid> 

                     

                    </Grid>
                  </DialogContent>
                  <Divider />

                  <DialogActions>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                    {updateId ? (
                      <Button
                        color="success"
                        variant="contained"
                        type="submit"
                      // onClick={()=>}
                      >
                        Updated
                      </Button>
                    ) : (
                      <Button
                        color="success"
                        variant="contained"
                        type="submit"
                      //   onClick={add_role_data}
                      >
                        Save
                      </Button>
                    )}
                  </DialogActions>
                </form>
              </>
            )}
          </>
        )}
      </Dialog>
    </>
  );
}